import { render, staticRenderFns } from "./article1.vue?vue&type=template&id=3ad63d32&scoped=true&lang=html&"
import script from "./article1.vue?vue&type=script&lang=js&"
export * from "./article1.vue?vue&type=script&lang=js&"
import style0 from "./article1.vue?vue&type=style&index=0&id=3ad63d32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad63d32",
  null
  
)

export default component.exports